import React from "react";
import { Link } from "gatsby";

import { LINK_DISTRIBUTION, PREVIEW } from "../../../../project-config";

export default function ChildCats({ cats }) {
  return (
    <div className="handwritten-forms-wrapper">
      {cats.map(cat => {
        const { URL, description, cid, thumbnail } = cat;

        return (
          <div className="handwritten-form-item-wrapper">
            <Link className="handwritten-form-item" to={`/${URL}`}>
              <h1
                dangerouslySetInnerHTML={{
                  __html: cat.name.replace("&amp;", "&")
                }}
              ></h1>
              <img
                src={`${LINK_DISTRIBUTION}/store${thumbnail}`}
                alt={"Image of " + description}
              />
              <div className="handwritten-form-item-shop-btn">
                <span>
                  Magasiner maintenant
                  <i className="material-icons">arrow_right</i>
                </span>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
}
